import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';

export class CustomerModel extends BaseModel implements Deserializable {

  // columns
  number: string;
  name: string;
  company: string;
  street: string;
  zip: string;
  city: string;
  country: string;
  phone: string;
  email: string;
  web: string;
  informations: string;

  public get address(): string {
    if (this.street && this.zip && this.city) {
      return this.street + ', ' + this.zip + ' ' + this.city;
    }
    return '-';
  }

}
